module.exports = __webpack_public_path__ + "static/media/newDriveStep2.0c007ace.svg";